
import { Component, Vue, Watch } from 'vue-property-decorator';
import index from '@/plugins/algoliasearch';
import SearchResult from '@/components/search/SearchResult.vue';
import axios from 'axios';

@Component({
  components: { SearchResult },
})
export default class Search extends Vue {
  query = '';
  page = 1;
  result: any = {};
  hits = [];
  total = 0;
  totalPages = 1;

  title() {
    return `「${this.$route.query.q}」の検索結果`;
  }

  @Watch('page')
  setPage() {
    this.$router.push({
      name: 'search',
      query: { q: this.query, page: this.page + '' },
    });
    this.search2();
  }

  @Watch('$route.query')
  async search2() {
    this.hits = [];
    this.query = this.$route.query.q as string;
    const page = this.$route.query.page as string;
    this.page = page ? parseInt(page) : 1;
    const result = await axios.get(
      'https://candra.dhii.jp/honkoku/solr_wrapper2.php',
      { params: { q: this.query, st: (this.page - 1) * 10 + 1, m: 'snippet' } },
    );
    console.log(result.data);
    this.hits = result.data.response.docs;
    this.total = result.data.response.numFound;
    this.totalPages = (this.total - (this.total % 10)) / 10 + 1;
  }

  // @Watch('$route.query')
  // async search() {
  //   this.query = this.$route.query.q as string;
  //   const page = this.$route.query.page as string;
  //   this.page = page ? parseInt(page) : 1;
  //   await index
  //     .setSettings({
  //       searchableAttributes: ['text'],
  //     })
  //     .catch((e) => console.log(e));
  //   this.result = await index.search({
  //     query: <string>this.$route.query.q,
  //     page: this.page - 1,
  //   });
  //   this.hits = this.result.hits;
  // }

  mounted() {
    this.search2();
  }

  created() {}
}
